import { gql } from "@apollo/client";
import {
  INTERVIEW_SCHEDULING_SETTING_FIELDS,
  INTERVIEW_SCHEDULING_REQUEST_FIELDS,
} from "graphql/queries/interviewSchedulingSettings";

const SAVE_INTERVIEW_SCHEDULING_SETTINGS = gql`
  ${INTERVIEW_SCHEDULING_SETTING_FIELDS}
  mutation SaveInterviewSchedulingSettings($input: SaveInterviewSchedulingSettingsInput!) {
    saveInterviewSchedulingSettings(input: $input) {
      interviewSchedulingSetting {
        ...InterviewSchedulingSettingFields
      }
    }
  }
`;

const PREPARE_INTERVIEW_SCHEDULING_REQUEST = gql`
  ${INTERVIEW_SCHEDULING_REQUEST_FIELDS}
  mutation PrepareInterviewSchedulingRequest($input: PrepareInterviewSchedulingRequestInput!) {
    prepareInterviewSchedulingRequest(input: $input) {
      interviewSchedulingRequest {
        ...InterviewSchedulingRequestFields
      }
    }
  }
`;

export { SAVE_INTERVIEW_SCHEDULING_SETTINGS, PREPARE_INTERVIEW_SCHEDULING_REQUEST };
